import { Group, Stack, StackProps } from '@mantine/core';
import { useState } from 'react';
import { OperationId, operations } from './operations';
import { useOperationsForm } from './settings/form/hooks/useOperationsForm';
import { OperationCard } from '../atoms/OperationCard';
import { FormProvider } from './settings/form/contexts/formContext';
import { SettingsRouter } from './settings/SettingsRouter';
import { Workflow } from '@/app/workflows/actions/interfaces';

import { useOperationListHandlers } from '@/app/workflows/components/v6/operations/hooks/useOperationListHandlers';
import { useGrowthbookContext } from '@/app/contexts/GrowthbookContext';
import { useWorkflow } from '../../../contexts/getWorkflow';

export function OperationList({ initialWorkflow, ...props }: { initialWorkflow: Workflow } & StackProps) {
  const growthbook = useGrowthbookContext();
  const [selectedOperation, setSelectedOperation] = useState<OperationId>(
    growthbook?.isOn('show-uvunwrap') ? 'uvUnwrapping' : 'limits'
  );
  const { getWorkflow } = useWorkflow();

  const workflow = getWorkflow() ?? initialWorkflow;
  const { form } = useOperationsForm(workflow);
  const { onEnabledOperationChanged } = useOperationListHandlers(workflow, form);
  const enabledOperations = workflow.clientMetadata?.enabledOperations ?? [];

  return (
    <Stack {...props}>
      <Group align='flex-start' wrap='nowrap'>
        <Stack pb='sm'>
          {operations
            .filter((o) => {
              // only allow uvUnwrapping if feature is on
              return o.id !== 'uvUnwrapping' || growthbook?.isOn('show-uvunwrap');
            })
            .map((operation, idx) => (
              <OperationCard
                key={operation.id}
                name={operation.name}
                description={operation.description}
                onClick={() => setSelectedOperation(operation.id)}
                isSelected={operation.id === selectedOperation}
                optional={
                  operation.optional && !operation.requiredWhenMissing?.some((i) => !enabledOperations.includes(i))
                }
                isEnabled={enabledOperations.includes(operation.id)}
                onEnabledChanged={(enabled) => onEnabledOperationChanged(operation.id, enabled)}
              />
            ))}
        </Stack>
        <FormProvider form={form}>
          {selectedOperation && <SettingsRouter id={selectedOperation} workflow={workflow} />}
        </FormProvider>
      </Group>
    </Stack>
  );
}
